/**
 *  Locations actions module file
**/

import { ACTIONS, MUTATIONS } from './constants'
import locationsService from '@/api/locationsService'
import buildQuery from '@/utils/buildQuery'

export const actions = {
  async [ACTIONS.FETCH_ADVERTS] ({ commit, rootState }, { reset, ...params } = {}) {
    commit(MUTATIONS.SET_LOADING, { key: 'adverts', flag: true })
    const filters = rootState.filters.filters
    const { query, meta, results } = await locationsService.getAdverts(params, filters)
    const sql = buildQuery(query)
    commit(MUTATIONS.SET_LOCATIONS, {
      key: 'adverts',
      query: sql,
      data: results,
      reset,
      meta
    })
  },
  async [ACTIONS.FETCH_SHOPS] ({ commit, rootState }, { reset, ...params } = {}) {
    commit(MUTATIONS.SET_LOADING, { key: 'shops', flag: true })
    const filters = rootState.filters.filters
    const { query, meta, results } = await locationsService.getShops(params, filters)
    const sql = buildQuery(query)
    commit(MUTATIONS.SET_LOCATIONS, {
      key: 'shops',
      query: sql,
      data: results,
      reset,
      meta
    })
  },
  async [ACTIONS.FETCH_POIS] ({ commit, rootState }, { reset, ...params } = {}) {
    commit(MUTATIONS.SET_LOADING, { key: 'pois', flag: true })
    const filters = rootState.filters.filters
    const { query, meta, results } = await locationsService.getPois(params, filters)
    const sql = buildQuery(query)
    commit(MUTATIONS.SET_LOCATIONS, {
      key: 'pois',
      query: sql,
      data: results,
      reset,
      meta
    })
  },
  async [ACTIONS.FETCH_ZONES] ({ commit }, { reset, ...params } = {}) {
    commit(MUTATIONS.SET_LOADING, { key: 'zones', flag: true })
    const { query, meta, results } = await locationsService.getPostalCodes(params)
    const sql = buildQuery(query)
    commit(MUTATIONS.SET_LOCATIONS, {
      key: 'zones',
      query: sql,
      data: results,
      reset,
      meta
    })
  },
  async [ACTIONS.FETCH_GRIDS] ({ commit }, { reset, ...params } = {}) {
    commit(MUTATIONS.SET_LOADING, { key: 'grids', flag: true })
    const { query, meta, results } = await locationsService.getGrids(params)
    const sql = buildQuery(query)
    commit(MUTATIONS.SET_LOCATIONS, {
      key: 'grids',
      query: sql,
      data: results,
      reset,
      meta
    })
  }
}
